// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expirationDate__eda {
  margin: calc(2 * var(--ring-unit)) 0;
}

.codeSnippet__e03 {
  margin: var(--ring-unit) 0;
}

.dialogContent__b2c {
  min-width: calc(65 * var(--ring-unit));
  max-width: 80vw;
}

.errorText__d88 {
  color: var(--ring-error-color);
  white-space: normal;
}

.dropzone__fdd {
  padding: calc(2 * var(--ring-unit));
}

.instructions__bfa {
  margin-top: var(--ring-unit);
  margin-bottom: calc(-2 * var(--ring-unit));
}

.instructionsContainer__f6d {
  display: flex;
  flex-direction: column;
  gap: calc(2 * var(--ring-unit));
  margin-top: calc(1.5 * var(--ring-unit));
}

.filePreviews__ed5 {
  margin-top: var(--ring-unit);
}

.filePreview__fa6 {
  flex-wrap: nowrap;
  display: flex;
  align-items: center;
}

.filePreviewRight__b80 {
  display: flex;
  flex-wrap: nowrap;
  text-align: right;
  align-items: center;
  justify-content: right;
  width: 100%;
}

.fileName__cfa {
  font-weight: bold;
  vertical-align: text-bottom;
  display: inline-block;
  white-space: nowrap;
  max-width: calc(35 * var(--ring-unit));
  margin-right: var(--ring-unit);
  text-overflow: ellipsis;
  overflow: hidden;
}

.fileSize__afd {
  display: inline-block;
  margin-right: var(--ring-unit);
}

.filePreviewIcon__d33 {
  align-items: center;
  display: inline-flex;
  height: calc(3.5 * var(--ring-unit));
  width: calc(2 * var(--ring-unit));
  padding: 0;
}

.channelsInfo__e4d {
  display: inline-block;
  margin-top: calc(2 * var(--ring-unit));
  border-bottom: 1px dotted var(--ring-secondary-color);
}

.channelsInfo__e4d:hover {
  cursor: default;
  color: var(--ring-link-hover-color);
  border-bottom: 1px dotted var(--ring-link-hover-color);
}

.channelsWrapper__ff8 {
  align-items: center;
}

.oneLineText__fe5 {
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/pages/plugins/upload-plugin/upload-plugin.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,sCAAsC;EACtC,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;EACpC,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".expirationDate {\n  margin: calc(2 * var(--ring-unit)) 0;\n}\n\n.codeSnippet {\n  margin: var(--ring-unit) 0;\n}\n\n.dialogContent {\n  min-width: calc(65 * var(--ring-unit));\n  max-width: 80vw;\n}\n\n.errorText {\n  color: var(--ring-error-color);\n  white-space: normal;\n}\n\n.dropzone {\n  padding: calc(2 * var(--ring-unit));\n}\n\n.instructions {\n  margin-top: var(--ring-unit);\n  margin-bottom: calc(-2 * var(--ring-unit));\n}\n\n.instructionsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: calc(2 * var(--ring-unit));\n  margin-top: calc(1.5 * var(--ring-unit));\n}\n\n.filePreviews {\n  margin-top: var(--ring-unit);\n}\n\n.filePreview {\n  flex-wrap: nowrap;\n  display: flex;\n  align-items: center;\n}\n\n.filePreviewRight {\n  display: flex;\n  flex-wrap: nowrap;\n  text-align: right;\n  align-items: center;\n  justify-content: right;\n  width: 100%;\n}\n\n.fileName {\n  font-weight: bold;\n  vertical-align: text-bottom;\n  display: inline-block;\n  white-space: nowrap;\n  max-width: calc(35 * var(--ring-unit));\n  margin-right: var(--ring-unit);\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.fileSize {\n  display: inline-block;\n  margin-right: var(--ring-unit);\n}\n\n.filePreviewIcon {\n  align-items: center;\n  display: inline-flex;\n  height: calc(3.5 * var(--ring-unit));\n  width: calc(2 * var(--ring-unit));\n  padding: 0;\n}\n\n.channelsInfo {\n  display: inline-block;\n  margin-top: calc(2 * var(--ring-unit));\n  border-bottom: 1px dotted var(--ring-secondary-color);\n}\n\n.channelsInfo:hover {\n  cursor: default;\n  color: var(--ring-link-hover-color);\n  border-bottom: 1px dotted var(--ring-link-hover-color);\n}\n\n.channelsWrapper {\n  align-items: center;\n}\n\n.oneLineText {\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"expirationDate": `expirationDate__eda`,
	"codeSnippet": `codeSnippet__e03`,
	"dialogContent": `dialogContent__b2c`,
	"errorText": `errorText__d88`,
	"dropzone": `dropzone__fdd`,
	"instructions": `instructions__bfa`,
	"instructionsContainer": `instructionsContainer__f6d`,
	"filePreviews": `filePreviews__ed5`,
	"filePreview": `filePreview__fa6`,
	"filePreviewRight": `filePreviewRight__b80`,
	"fileName": `fileName__cfa`,
	"fileSize": `fileSize__afd`,
	"filePreviewIcon": `filePreviewIcon__d33`,
	"channelsInfo": `channelsInfo__e4d`,
	"channelsWrapper": `channelsWrapper__ff8`,
	"oneLineText": `oneLineText__fe5`
};
export default ___CSS_LOADER_EXPORT___;
